"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var EmbedModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const validate_js_1 = require("validate.js");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const form_2 = require("../_components/form");
const Embed_contracts_1 = require("./Embed.contracts");
const EmbedIframe_form_1 = require("./versions/iframe/EmbedIframe.form");
const EmbedYouTube_form_1 = require("./versions/youtube/EmbedYouTube.form");
const form_3 = require("./versions/form");
const EmbedTwitter_form_1 = require("./versions/twitter/EmbedTwitter.form");
const EmbedVideo_form_1 = require("./versions/video/EmbedVideo.form");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `Embed`'s contents.
 *
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let EmbedModuleForm = EmbedModuleForm_1 = class EmbedModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.EmbedVersion = Embed_contracts_1.EmbedVersion;
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * TODO: Move these regExp's to their own version forms
         * RegularExpressions to identify embed source
         */
        this.twitterRegex = /twitter\.com\/.*\/status(?:es)?\/([^/?]+)/;
        this.youtubeRegex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch?))\??v?=?([^#&?"]*).*/;
        this.facebookRegex = /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?([\w-]*)?\/(?:[\w-]*)?\/([\w-]*)/;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = EmbedModuleForm_1.getInitialContent();
        /**
         * Title of the image.
         */
        this.imgTitle = '';
        /**
         * Image.
         */
        this.thumbnail = null;
        /**
         * Active tab according to `_version`
         */
        this.activeTab = 'pdf';
        /**
         * Selected related file
         */
        this.file = null;
        /**
         * Selected related video
         */
        this.video = null;
    }
    /**
     * Tabs
     *
     * @see DashmixBoxTabItem
     */
    get embedOptions() {
        return [
            {
                component: EmbedIframe_form_1.EmbedIframePartialForm,
                props: {
                    content: this._content
                },
                tab: {
                    id: 'iframe',
                    disabled: this.isTabDisabled,
                    label: 'IFrame'
                }
            },
            {
                component: form_3.EmbedPdfPartialForm,
                props: {
                    content: this._content,
                    onSelection: this.findPdfFileSource,
                    onRemove: this.removePdfFile,
                    file: this.file || {}
                },
                tab: {
                    id: 'pdf',
                    disabled: this.isTabDisabled,
                    label: 'PDF'
                }
            },
            {
                component: EmbedTwitter_form_1.EmbedTwitterPartialForm,
                props: {
                    content: this._content
                },
                tab: {
                    id: 'twitter',
                    disabled: this.isTabDisabled,
                    label: 'TWITTER'
                }
            },
            {
                component: EmbedYouTube_form_1.EmbedYouTubePartialForm,
                props: {
                    content: this._content,
                    imgTitle: this.imgTitle,
                    onAutoplayToggle: this.toggleAutoplay,
                    onSelection: this.findThumbnailSource,
                    onRemove: this.removeThumbnail,
                    onVideoIdChange: this.onVideoIdChange,
                    thumbnail: this.thumbnail
                },
                tab: {
                    id: 'youtube',
                    disabled: this.isTabDisabled,
                    label: 'YouTube'
                }
            },
            {
                component: EmbedVideo_form_1.EmbedVideoPartialForm,
                props: {
                    content: this._content,
                    onSelection: this.findVideoFileSource,
                    onThumbnailSelection: this.findThumbnailSource,
                    onRemove: this.removeVideoFile,
                    onThumbnailRemove: this.removeThumbnail,
                    file: this.video || {},
                    imgTitle: this.imgTitle,
                    thumbnail: this.thumbnail
                },
                tab: {
                    id: 'video',
                    disabled: this.isTabDisabled,
                    label: 'Video'
                }
            },
            {
                component: form_3.EmbedVideoSwitchPartialForm,
                props: {
                    content: this._content,
                    onSelection: this.findVideoFileSource,
                    onVideoIdYoutubeChange: this.onVideoIdYoutubeChange,
                    onVideoIdOnHashChange: this.onVideoIdOnHashChange,
                    onThumbnailSelection: this.findThumbnailSource,
                    onAutoplayToggle: this.toggleAutoplay,
                    onRemove: this.removeVideoFile,
                    onThumbnailRemove: this.removeThumbnail,
                    file: this.video || {},
                    imgTitle: this.imgTitle,
                    thumbnail: this.thumbnail
                },
                tab: {
                    id: 'video_switch',
                    disabled: this.isTabDisabled,
                    label: 'VideoSwitch'
                }
            }
        ];
    }
    /**
     * Check whether module is editing and disable tab
     */
    get isTabDisabled() {
        return (this.isEditMode && this._content.version === this._version);
    }
    /**
     * TODO: Description.
     */
    checkType(data) {
        if (!data) {
            return;
        }
        const youtubeMatch = data.match(this.youtubeRegex);
        if (youtubeMatch) {
            this._version = Embed_contracts_1.EmbedVersion.YouTube;
            this._content = {
                ...this._content,
                iframe: '',
                videoId: youtubeMatch[7]
            };
        }
        else {
            this._content.videoId = '';
            this._content.iframe = data;
        }
    }
    /**
     * TODO: Description.
     */
    findThumbnailSource() {
        this.pickRelated(services_1.Picker.Media, this.setThumbnailSource);
    }
    findPdfFileSource() {
        this.pickRelated(services_1.Picker.Media, this.setPdfFileSource, this._content.pdf, { allowedMediaType: _contracts_1.FileType.Document });
    }
    findVideoFileSource() {
        this.pickRelated(services_1.Picker.Media, this.setVideoFileSource, this._content.video, { allowedMediaType: _contracts_1.FileType.Video });
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Embed,
            size: {
                colSpan: 2,
                rowSpan: 2,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            },
            version: Embed_contracts_1.EmbedVersion.YouTube
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            autoplay: false,
            description: '',
            iframe: '',
            pdf: {},
            pdfAsLink: false,
            thumbnail: {},
            video: {}
        };
    }
    /**
     * TODO: Description.
     */
    hasImage() {
        return !!this._content.thumbnail && typeof this._content.thumbnail.value !== 'undefined';
    }
    /**
     * TODO: Description.
     */
    get iframe() {
        return this._content.iframe || '';
    }
    set iframe(value) {
        this._content.iframe = value;
    }
    /**
     * TODO: Description.
     */
    removeThumbnail() {
        this._content.thumbnail = {};
    }
    removePdfFile() {
        this._content.pdf = {};
    }
    removeVideoFile() {
        this._content.video = {};
    }
    onVideoIdChange(id) {
        this._content = {
            ...this._content,
            videoId: id
        };
    }
    onVideoIdYoutubeChange(id) {
        this._content = {
            ...this._content,
            videoIdYoutube: id
        };
    }
    onVideoIdOnHashChange(id) {
        this._content = {
            ...this._content,
            videoIdOnHash: id
        };
    }
    toggleAutoplay(auto) {
        const content = this._content;
        content.autoplay = auto;
        this._content = content;
    }
    getImageFromRelated(related) {
        if (Object.prototype.hasOwnProperty.call(related, 'alt')) {
            this.imgTitle = related.title;
        }
        if (Object.prototype.hasOwnProperty.call(related, 'url')) {
            this.thumbnail = {
                type: backoffice_1.ImageType.JPG,
                thumbnail: related.url
            };
            if (Object.prototype.hasOwnProperty.call(related, 'mime')) {
                this.thumbnail.type = related.mime;
            }
        }
    }
    /**
     * Describes PDF's related
     * @protected
     */
    describePdfFileRelated() {
        if (!this._content.pdf || typeof this._content.pdf.value === 'undefined' ||
            typeof this._content.pdf.type === 'undefined') {
            return;
        }
        const promise = this.relatedService.resolve(this._content.pdf);
        if (!validate_js_1.isPromise(promise)) {
            const file = promise;
            this.file = {
                type: backoffice_1.DocumentType.PDF,
                fileDescription: file.title || file.caption || file.alt,
                fileUrl: file.url
            };
            return;
        }
        promise.then((file) => {
            this.file = {
                type: backoffice_1.DocumentType.PDF,
                fileDescription: file.title || file.caption || file.alt,
                fileUrl: file.url
            };
        }).catch((e) => {
            console.warn(e);
        });
    }
    /**
     * Describes Video's related
     * @protected
     */
    describeVideoFileRelated() {
        if (!this._content.video || typeof this._content.video.value === 'undefined' ||
            typeof this._content.video.type === 'undefined') {
            return;
        }
        const promise = this.relatedService.resolve(this._content.video);
        if (!validate_js_1.isPromise(promise)) {
            const file = promise;
            this.video = {
                ...file,
                fileDescription: file.title || file.caption || file.alt
            };
            return;
        }
        promise.then((file) => {
            this.video = {
                ...file,
                fileDescription: file.title || file.url
            };
        }).catch((e) => {
            console.warn(e);
        });
    }
    /**
     * TODO: Description.
     */
    findImageRelated() {
        if (!this._content.thumbnail || typeof this._content.thumbnail.value === 'undefined' ||
            typeof this._content.thumbnail.type === 'undefined') {
            return;
        }
        const related = this.relatedService.resolve(this._content.thumbnail, {});
        if (!validate_js_1.isPromise(related)) {
            this.getImageFromRelated(related);
            return;
        }
        related.then((related) => {
            this.getImageFromRelated(related);
        }).catch(error => {
            console.debug(error);
        });
    }
    /**
     * TODO: Description.
     */
    onIframeChange(newIframe) {
        this.checkType(newIframe);
        const iFrameEnd = newIframe.lastIndexOf('</iframe>') + '</iframe>'.length;
        const iFrameStart = newIframe.indexOf('<iframe');
        if (iFrameEnd < 0 || iFrameStart < 0) {
            return;
        }
        const trimIframe = newIframe.substr(iFrameStart, iFrameEnd);
        if (trimIframe !== newIframe) {
            this.iframe = trimIframe;
        }
    }
    /**
     * TODO: Description.
     */
    setThumbnailSource(source) {
        this._content.thumbnail = source;
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    setPdfFileSource(source) {
        this._content.pdf = source;
        this.$nextTick(() => {
            this.describePdfFileRelated();
        });
    }
    setVideoFileSource(source) {
        this._content.video = source;
        this.$nextTick(() => {
            this.describeVideoFileRelated();
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], EmbedModuleForm.prototype, "isEditMode", void 0);
__decorate([
    vue_property_decorator_1.Watch('iframe'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EmbedModuleForm.prototype, "onIframeChange", null);
EmbedModuleForm = EmbedModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedModuleForm',
        components: {
            DashmixBoxTabs: backoffice_1.DashmixBoxTabs,
            FormErrors: form_2.FormErrors
        },
        mounted() {
            this.$nextTick(() => {
                switch (this._version) {
                    case Embed_contracts_1.EmbedVersion.YouTube:
                        if (typeof this._content.autoplay === 'undefined') {
                            this.toggleAutoplay(false);
                        }
                        this.findImageRelated();
                        break;
                    case Embed_contracts_1.EmbedVersion.PDF:
                        this.describePdfFileRelated();
                        break;
                    case Embed_contracts_1.EmbedVersion.Video:
                        this.describeVideoFileRelated();
                        this.findImageRelated();
                        break;
                    case Embed_contracts_1.EmbedVersion.VideoSwitch:
                        if (typeof this._content.autoplay === 'undefined') {
                            this.toggleAutoplay(false);
                        }
                        this.describeVideoFileRelated();
                        this.findImageRelated();
                        break;
                }
            });
        },
        template: `
    <div class="embed-form">
    <DashmixBoxTabs :items="embedOptions" :active.sync="_version"/>
    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }"/>
    </div>
  `
    })
], EmbedModuleForm);
exports.EmbedModuleForm = EmbedModuleForm;
//# sourceMappingURL=Embed.form.js.map